import { ITabs_Types } from 'types/interfaces';

export const PROPOSALS = 'proposals';
export const VOTES = 'votes';

export const TABLE_TABS_TYPES: ITabs_Types = {
    [VOTES]: VOTES,
    [PROPOSALS]: PROPOSALS,
};
